import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../../Button';

const propTypes = {
  onCreateEvent: PropTypes.func.isRequired,
  isSmsSent: PropTypes.bool.isRequired,
};

const SuccessForm = ({ onCreateEvent, isSmsSent }) => {
  return (
    <Fragment>
      {isSmsSent ? (
        <p className="mb-3 text-center">
          We&apos;ve sent you an SMS detailing how you can easily add photos to
          the live slideshow.
          <br />
          <br />
          Check your messages!
        </p>
      ) : (
        <p className="mb-3 text-center">
          Send your photos via SMS so Waldo can add them to the live slideshow!
        </p>
      )}
      <p className="mt-6 text-center">
        Got an event coming up? <br />
        <span className="text-extra-bold text-dark">
          Gather &amp; share your photos easily by <br />
          creating your own Waldo Event!
        </span>
      </p>
      <div className="text-center">
        <Button btnBlock onClick={onCreateEvent}>
          Create an event
        </Button>
      </div>
    </Fragment>
  );
};

SuccessForm.propTypes = propTypes;

export default SuccessForm;
